import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import constant from '../../../constant';

const ShipyardForm = ({ data, onSubmit, title }) => {
    const [state, setState] = useState({
        shipyardName: {
            name: 'shipyardName',
            value: data?.SHIPYARD_NAME || '',
            isRequired: true,
            error: '',
        },
        shipyardCode: {
            name: 'shipyardCode',
            value: data?.SHIPYARD_CODE || '',
            isRequired: false,
            error: '',
        },
        registrationNumber: {
            name: 'registrationNumber',
            value: data?.REGISTRATION_NUMBER || '',
            isRequired: false,
            error: '',
        },
        contactPerson: {
            name: 'contactPerson',
            value: data?.CONTACT_PERSON || '',
            isRequired: true,
            error: '',
        },
        contactEmail: {
            name: 'contactEmail',
            value: data?.CONTACT_EMAIL || '',
            isRequired: false,
            error: '',
        },
        contactPhone: {
            name: 'contactPhone',
            value: data?.CONTACT_PHONE || '',
            isRequired: false,
            error: '',
        },
        isActive: {
            name: 'isActive',
            value: data?.IS_ACTIVE ?? true,
            isRequired: false,
        },
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : '',
            },
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };

    const handleReset = () => {
        const resetState = { ...state };
        Object.keys(resetState).forEach(key => {
            resetState[key].value = data?.[key.toUpperCase()] || (key === 'isActive' ? true : '');
            resetState[key].error = '';
        });
        setState(resetState);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                {[ 
                    { label: 'Shipyard Name', name: 'shipyardName', placeholder: 'Enter shipyard name' },
                    { label: 'Shipyard Code', name: 'shipyardCode', placeholder: 'Enter shipyard code' },
                    { label: 'Registration Number', name: 'registrationNumber', placeholder: 'Enter registration number' },
                    { label: 'Contact Person', name: 'contactPerson', placeholder: 'Enter contact person name' },
                    { label: 'Contact Email', name: 'contactEmail', placeholder: 'Enter contact email' },
                    { label: 'Contact Phone', name: 'contactPhone', placeholder: 'Enter contact phone' },
                ].map(({ label, name, placeholder }) => (
                    <div className="col-md-6 mb-3" key={name}>
                        <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
                        <input
                            type="text"
                            name={state[name].name}
                            value={state[name].value}
                            onChange={handleChange}
                            placeholder={placeholder}
                            className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
                        />
                        {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
                    </div>
                ))}

                <div className="col-md-4 form-check ms-2 mt-2">
                    <input
                        type="checkbox"
                        name={state.isActive.name}
                        checked={state.isActive.value}
                        onChange={handleChange}
                        className="form-check-input"
                        id="isActive"
                    />
                    <label className="form-check-label" htmlFor="isActive">Active</label>
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a className="btn btn-danger text-white" href={constant.Authedcomponent.listShipYardMasterData.url}>
                    Cancel
                </a>
            </div>
        </form>
    );
};

export default ShipyardForm;
